import Layout from '@/layout/index.vue';

export default [
  {
    path: '/workOrderManage/formal',
    component: Layout,
    name: 'workOrderManage',
    meta: {
      title: '工单管理',
      icon: 'el-icon-s-finance',
      alwaysShow: true, // 即使只有一个子路由也显示父级菜单
    },
    children: [
      {
        path: 'list',
        name: 'workOrderList',
        component: () => import('@/views/workOrder/orderList.vue'),
        meta: { title: '工单列表', icon: 'el-icon-s-management' },
      },
      {
        path: 'statistics',
        name: 'workOrderStatistics',
        component: () => import('@/views/workOrder/borderSta.vue'),
        meta: { title: '工单统计', icon: 'el-icon-s-management' },
      },
      {
        path: 'analyse',
        name: 'analyse',
        component: () => import('@/views/appManage/poManage/fault_list.vue'),
        meta: { title: '工单分析', icon: 'el-icon-s-management' },
      },
    ],
  },
];
